module.exports = __webpack_public_path__ + "img/TickSquare@3x.afffeb52.png";